<template>
  <div class="keyboard-layout" :style="`margin: 0 auto; max-width: ${maxWidth}`">
    <KeyRow @layout="e => $emit('layout', e)" :row="row" :key="idx" v-for="(row, idx) in layout" :control_states="control_states" @click="keyClick" />
  </div>
</template>
 
<script>

import KeyRow from './KeyRow.vue'

export default {
  props: {
    layout: Array,
    control_states: Object
  },
  methods:{
    whichStateKey(key) {
      return ['ctrl', 'shift', 'alt', 'caps'].includes(key) ? key : undefined
    },
    whichFunctionalKey(key) {
      return ['esc', 'tab', 'enter', 'backspace', 'space'].includes(key) ? key : undefined
    },
    dropControlStates(){
      this.$emit('controlStates', {
        ctrl: false,
        shift: false,
        alt: this.control_states.alt || false,
        caps: this.control_states.caps || false
      })
    },
    processStateKey(key){
      let new_states = {...this.control_states}
      new_states[key] = !this.control_states[key]
      this.$emit('controlStates', new_states)
    },
    processFunctionalKey(key){
      this.$emit('funcKey', key)
      // this.dropControlStates()
    },
    processLetterKey(key){
      this.$emit('letterKey', this.uppercase ? key.toUpperCase() : key.toLowerCase())
      // this.dropControlStates()
    },
    keyClick(key) {
      
      let state_key = this.whichStateKey(key)
      if (state_key) {
        this.processStateKey(key)
        return
      } 

      let func_key = this.whichFunctionalKey(key)
      if(func_key) {
        this.processFunctionalKey(key)
        return
      }

      this.processLetterKey(key)
    }
  },
  computed: {
    maxWidth(){
      let max_keys = 0
      for (let row of this.layout) {
        if (row.length > max_keys) {
          max_keys = row.length
        }
      }

      return `calc(${max_keys*4}em + ${max_keys*4}px + ${max_keys}px)` 
    },
    uppercase(){
      if (this.control_states.caps) {
        return this.control_states.shift ? false : true
      } else {
        return this.control_states.shift ? true : false
      }
    }
  },
  components: {
    KeyRow
  }
}
</script>

<style scoped>
.keyboard-layout {
  /* display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; */
  /* max-width: 960px; */
  margin: 0 auto;
}
</style>